import React from "react";
//import { useSelector } from "react-redux";
import { useHistory } from "react-router";

function Header() {
  //const { cart } = useSelector((store) => store);
  const history = useHistory();

  return (
    <nav>
      <div onClick={() => history.push("/")} className="logo">
        Numismatas
      </div>
      

      <div className="search">
        
        <i
          onClick={() => history.push("/cart")}
          className="fa fa-shopping-basket"
        > Seu Cofre</i>
      </div>
    </nav>
  );
}

export default Header;
